import { InferGetStaticPropsType, NextPage } from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  GovernanceOverviewDocument,
  GovernanceOverviewQuery,
  GovernanceOverviewQueryVariables,
  GovHeroDocument,
  GovHeroQuery,
  GovHeroQueryVariables,
  GovInvestorsSectionDocument,
  GovInvestorsSectionQuery,
  GovInvestorsSectionQueryVariables,
  GovProductImageBlockDocument,
  GovProductImageBlockQuery,
  GovProductImageBlockQueryVariables,
  GovSeoDocument,
  GovSeoQuery,
  GovSeoQueryVariables,
  GovTeamDocument,
  GovTeamQuery,
  GovTeamQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { GovPage } from '@/views/governance';

export const getStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: GovSeoDocument });
  await client.query({ query: GovHeroDocument });
  await client.query({ query: GovernanceOverviewDocument });
  await client.query({ query: GovInvestorsSectionDocument });
  await client.query({ query: GovTeamDocument });
  await client.query({ query: GovProductImageBlockDocument });
  await client.query({ query: NavigationDocument });
  await client.query({ query: FooterDocument });

  const { data: seoData } = await client.query<
    GovSeoQuery,
    GovSeoQueryVariables
  >({ query: GovSeoDocument });

  const { data: heroData } = await client.query<
    GovHeroQuery,
    GovHeroQueryVariables
  >({
    query: GovHeroDocument,
  });

  const { data: governanceData } = await client.query<
    GovernanceOverviewQuery,
    GovernanceOverviewQueryVariables
  >({
    query: GovernanceOverviewDocument,
  });

  const { data: investorsData } = await client.query<
    GovInvestorsSectionQuery,
    GovInvestorsSectionQueryVariables
  >({
    query: GovInvestorsSectionDocument,
  });

  const { data: teamData } = await client.query<
    GovTeamQuery,
    GovTeamQueryVariables
  >({
    query: GovTeamDocument,
  });

  const { data: productImageBlockData } = await client.query<
    GovProductImageBlockQuery,
    GovProductImageBlockQueryVariables
  >({ query: GovProductImageBlockDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({
    query: NavigationDocument,
  });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({
    query: FooterDocument,
  });

  return addApolloState(client, {
    props: {
      seoData,
      heroData,
      governanceData,
      investorsData,
      teamData,
      productImageBlockData,
      headerData,
      footerData,
    },
  });
};

const Governance: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  seoData,
  heroData,
  governanceData,
  investorsData,
  teamData,
  productImageBlockData,
  headerData,
  footerData,
}) => (
  <GovPage
    seo={seoData?.governance?.data?.attributes?.seo}
    hero={heroData?.governance?.data?.attributes?.hero}
    governance={governanceData?.governance?.data?.attributes?.governanceSection}
    investors={investorsData?.governance?.data?.attributes?.investorsSection}
    team={teamData?.governance?.data?.attributes?.team}
    productImageBlock={
      productImageBlockData?.governance?.data?.attributes?.productImageBlock
    }
    header={headerData}
    footer={footerData}
  />
);

export default Governance;
